<template lang="html">
	<wizard-screen
		panel-class="omapi-panel__4-2"
		:completed="4"
		:total="5"
		:nav-next="!showUpsell"
		nav-next-text="Continue"
	>
		<h2>Finalize Adding Features</h2>
		<div v-if="showUpsell" class="omapi-happy-text">
			To enable the conversion features you selected earlier, you need to upgrade to OptinMonster Pro.
		</div>
		<div v-else class="omapi-happy-text">The following features have been added to your account.</div>

		<core-loading v-if="isLoading" size="40px" />
		<div v-else>
			<wizard-feature v-for="feature in proFeatures" :key="feature.slug" :feature="feature" />
		</div>

		<div v-if="showUpsell" class="omapi-box__gray">
			<h3>OptinMonster comes with a free license for WordPress users 😀</h3>
			<p>
				If you choose to upgrade to Pro, you will receive a <b>35% discount</b> - automatically applied at
				checkout.
			</p>
			<core-upgrade-button
				class="omapi-button omapi-wizard-forward omapi-button__green"
				utm-medium="Wizard"
				:features="extraFeatures"
				@click="$bus.$emit('onboardingNextPage')"
			>
				Upgrade Now &amp; Save 35%
			</core-upgrade-button>
		</div>

		<a
			v-if="showUpsell"
			href="#"
			class="omapi-link-arrow-after omapi-wizard-forward-link"
			@click.prevent="$bus.$emit('onboardingNextPage')"
		>
			Skip this Step and Continue with OptinMonster Lite (free version)
		</a>
	</wizard-screen>
</template>

<script lang="js">
import { mapState, mapGetters, mapActions } from 'vuex'
import { screen } from './mixins/screen'

export default {
	mixins : [ screen ],
	data () {
		return {
			isLoading : false,
		}
	},
	computed : {
		...mapState([ 'apiKey' ]),
		...mapGetters([ 'showProUpsells' ]),
		...mapGetters('wizard', [ 'proFeatures', 'inExtraFeatures' ]),
		...mapState('plugins', [ 'plugins' ]),
		...mapGetters('plugins', [ 'byId' ]),
		pluginIds () {
			return this.featureMap.filter(f => {
				return f.plugin && this.inExtraFeatures(f.slug)
			}).map(feature => {
				return feature.plugin.slug
			})
		},
		showUpsell () {
			return this.proFeatures.find(f => {
				const feature = f.featureId || f.slug
				return !this.$store.getters.hasFeature(feature) && !this.$store.getters.hasRuleType(feature)
			})
		},
	},
	mounted () {
		if (!this.extraFeatures.length) {
			return this.skip()
		}

		if (this.pluginIds.length && this.apiKey) {
			this.isLoading = true
			this.fetchPlugins().then(this.activatePlugins)
		}
	},
	methods : {
		...mapActions('plugins', {
			fetchPlugins : 'fetch',
			pluginAction : 'action',
		}),
		activatePlugins () {
			if (!this.pluginIds.length) {
				this.isLoading = false
				return
			}

			const actionPromises = []

			this.pluginIds.forEach((pluginId) => {
				const promise = this.pluginAction(pluginId)
					.catch((error) => {
						if (!error.explanation) {
							const plugin = this.byId(pluginId)
							// eslint-disable-next-line no-console
							console.error(`Could not install/activate ${plugin ? plugin.name : pluginId}`, { error })
						}
					})
				actionPromises.push(promise)
			})

			Promise.all(actionPromises)
				.then(() => {
					this.isLoading = false
					if (this.extraFeatures.length === this.pluginIds.length) {
						return this.skip()
					}
				})
		},
	},
};
</script>

<style scoped lang="scss">
@import '../assets/scss/variables';
.omapi-screen .omapi-panel__4-2 {
	.omapi-box__gray {
		margin: 50px 0 33px;
		p {
			font-size: 14px;
			margin-bottom: 10px;
		}
	}

	.omapi-wizard-forward {
		border-radius: 3px;
		font-size: 16px;
		margin-top: 10px;
		padding: 16px 24px;
	}

	a.omapi-wizard-forward-link {
		color: $font_secondary-color;
		font-size: 14px;
		line-height: 100%;
	}
}
</style>
